import { render, staticRenderFns } from "./FaceDetectedFixedToggleBar.vue?vue&type=template&id=5884b76c&scoped=true&"
import script from "./FaceDetectedFixedToggleBar.vue?vue&type=script&lang=js&"
export * from "./FaceDetectedFixedToggleBar.vue?vue&type=script&lang=js&"
import style0 from "./FaceDetectedFixedToggleBar.vue?vue&type=style&index=0&id=5884b76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884b76c",
  null
  
)

export default component.exports